"use client";

import { c as _c } from "react/compiler-runtime";
import { useUrlFilters } from "@/hooks/use-url-filters";
import { useSearchPageMapData } from "@/providers/search";
import { SearchList } from "../list";
import { SEOContentForSearch } from "../list/seo/content";
import { SearchMap } from "../map";
import { UnifiedMapControls } from "../map/unified-map-controls";
interface MobileLayoutProps {
  view: "map" | "list";
  onViewChange: (view: "map" | "list") => void;
}
export function MobileLayout(t0) {
  const $ = _c(11);
  const {
    view,
    onViewChange
  } = t0;
  const totalPropertiesCount = useSearchPageMapData(_temp);
  const shouldShowSeoBanner = view === "list";
  const {
    filters
  } = useUrlFilters();
  let t1;
  if ($[0] !== filters || $[1] !== onViewChange || $[2] !== view) {
    t1 = <UnifiedMapControls view={view} onViewChange={onViewChange} showViewToggles={true} filters={filters} className="fixed bottom-4 right-4" isMobile={true} />;
    $[0] = filters;
    $[1] = onViewChange;
    $[2] = view;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== shouldShowSeoBanner || $[5] !== totalPropertiesCount || $[6] !== view) {
    t2 = <div className="w-full h-full">{view === "map" ? <div className="w-full h-[calc(100vh-var(--header-height))] relative"><SearchMap mapControlsClassName="!hidden" /></div> : <div className="w-full flex flex-col"><div className="w-full h-[calc(100vh-var(--header-height))]"><SearchList className="h-full" /></div>{shouldShowSeoBanner && totalPropertiesCount > 0 && <div className="w-full bg-gradient-to-r from-[#251821] to-[#31202C] min-h-[20vh] flex items-center justify-center"><SEOContentForSearch /></div>}</div>}</div>;
    $[4] = shouldShowSeoBanner;
    $[5] = totalPropertiesCount;
    $[6] = view;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp(state) {
  return state.mapData?.length || 0;
}